import React from "react";

import { oQueE } from "../../../utils/copy";
import manuRetratoClinica from "../../../assets/images/ConversasTerapeuticas/oqueé.jpg";

export function ManuelaClinica() {
  return (
    <section id="o-que-e" data-bg="#2c171e" className="poster-section clinic-section dark-sec">
      {/* Retrato: no desktop preenche a coluna esquerda; no mobile vira
          moldura de papel rasgado (camada mobile). */}
      <div className="clinic-media">
        <figure data-motion="media" className="clinic-photo">
          <span className="clinic-photo-frame">
            <span className="clinic-photo-zoom">
              <img
                src={manuRetratoClinica}
                alt="Retrato de Manuela Xavier, psicanalista, sorrindo de avental diante de uma peça de cerâmica, sobre fundo amarelo"
                className="absolute inset-0 h-full w-full object-cover"
              />
            </span>
          </span>
        </figure>
      </div>

      <div className="clinic-panel">
        <p className="clinic-kicker">02 · {oQueE.kicker}</p>
        <p data-motion="lead" className="type-voice clinic-lead">
          {oQueE.lead}
        </p>
        <div data-motion="gesture" aria-hidden="true" className="clinic-connector"><b>*</b><i /></div>
        {/* corpo de leitura: definição curta do produto; o selo e o percurso
            trimestral viraram o pôster amarelo logo abaixo (doc jul/2026). */}
        <p data-motion="title" className="clinic-body">{oQueE.corpo}</p>
        <p data-motion="title" className="clinic-quote">
          <em>{oQueE.quote.destaque}</em>
        </p>
      </div>
    </section>
  );
}
